module.exports = __webpack_public_path__ + "img/avatar-5.427d08f0.jpeg";